export enum USER_ROLE {
    ADMIN = 'admin',
    SELLER = 'seller',
}
